export default __webpack_public_path__ + "static/mob-banner-9958d00b487351e63ed25b9c6cae3c0f.png";